var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toastr-overlay"},_vm._l((_vm.toasts),function(toastr){return _c('Toast',{key:toastr.id,attrs:{"id":toastr.id,"title":toastr.title,"message":toastr.message,"type":toastr.type,"timeout":toastr.options.timeout}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }